export default __webpack_public_path__ + "static/media/img14.8974af6f.PNG";